import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import FlexChild from "layouts/flex/FlexChild";

import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// import { HOST } from "routes/front/main/WebSocketContainer";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import itemDispensing from "resources/img/itemDispensing.png";
import itemDispensingSound from "resources/music/itemDispensingSound.mp3";
import completeImg from "resources/img/puffu/gif/complete.gif";
import ProcessBar from "routes/front/main/vending/mainPage/ProcessBar";



const ItemDispensingModal = NiceModal.create(props => {
    const { t } = useTranslation();
    const [withHeader, withFooter] = [false, false];
    const [width, height] = ["80%", "50%"];
    const withCloseButton = false;
    const modal = useRef();
    const clickOutsideToClose = false;
    const title = t("");
    const buttonText = t("close");
    const audioRef = useRef();

    useEffect(() => {
        return (
            audioRef.current.play()
        );
    }, [])



    return (
        <ModalBase
            ref={modal}
            width={width}
            height={height}
            withHeader={withHeader}
            withFooter={withFooter}
            withCloseButton={withCloseButton}
            clickOutsideToClose={clickOutsideToClose}
            title={title}
            buttonText={buttonText}
            overflow={"visible"}
            borderRadius={"25px"}
            onClose={props.onClose}
        >
            <audio ref={audioRef} src={itemDispensingSound} preload="auto" />
            <VerticalFlex padding={"4vw"} gap={30}>
                <FlexChild height={"max-content"}>
                    <ProcessBar modal payment />
                    <div style={{ width: "100%", height: "2px", backgroundColor: "black" }} />
                </FlexChild>
                <FlexChild height={"max-content"}>
                    <P color={"black"} font={"gmarketSansBold"} weight={"bold"} size={"3.2vw"}>결제가 완료되었습니다.</P>
                    <P size={17}>구매해주셔서 감사합니다.</P>
                </FlexChild>
                <FlexChild height={"2px"} backgroundColor={"#eee"} />
                <FlexChild height={"max-content"}>
                    <P font={"gmarketSansBold"} color={"var(--main-color)"} size={"3.2vw"}>고객님의 물건을 준비하고 있어요!</P>
                </FlexChild>
                <FlexChild>
                    <img src={itemDispensing} width={"70%"} />
                </FlexChild>


            </VerticalFlex>
        </ModalBase>
    );
});

export default ItemDispensingModal;
